import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { getBooks } from '../lib/api';

function Libros() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBooks()
      .then((data) => setBooks(data.books))
      .catch(() => setBooks([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <Seo title="Libros" description="Biblioteca de libros reseñados y recomendados en Libros para Viajeros." />
      <h1>Libros</h1>
      <p className="page__intro">La biblioteca completa de libros reseñados y recomendados.</p>

      {!loading && books.length === 0 && <p className="empty-state">Todavía no hay libros publicados.</p>}
      <div className="card-grid">
        {books.map((book) => (
          <Link key={book.id} to={`/libros/${book.slug}`} className="content-card">
            {book.cover_url && <img src={book.cover_url} alt={book.title} />}
            <div className="content-card__body">
              <h3 className="content-card__title">{book.title}</h3>
              {book.genre && <p className="content-card__excerpt">{book.genre}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Libros;
